export const LIMIT_ATTACH_IMAGES = 7;
//# sourceMappingURL=constants.js.map